import Apis from '@/Apis/_'
import ResponseApi from '../interfaces/FactoryResponse'
import { CoreBase, ICoreBase } from './CoreBase'
import { AgendamentoTriagemConfirmar } from '../interfaces/backoffice-hospital/agendamento/AgendamentoTriagemConfirmar'

class Triagem extends CoreBase implements ITriagem {
  async confirmarTriagem(triagem: AgendamentoTriagemConfirmar): Promise<ResponseApi> {
    const { solicitacaoId } = triagem
    // let response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.putNovaDataSolicitacao(solicitacaoId, triagem)
    // if (response.success) {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.backofficeAgendamentoRealizaTriagem(solicitacaoId, triagem)
    // }

    return response
  }

  async backofficeAgendamentoRealizaTriagem(solicitacaoId: string, triagem: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.backofficeAgendamentoRealizaTriagem(solicitacaoId, triagem)
    return response
  }

  async backofficeAgendamentoRealizaTriagemParticular(solicitacaoId: string, triagem: any): Promise<ResponseApi> {
    if (triagem.hospitalFazReservaDeSala) {
      const fazReservaRequest = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.backofficeAgendamentoRealizaTriagem(solicitacaoId, triagem)
      return fazReservaRequest
    }

    const request = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.backofficeAgendamentoRealizaTriagem(solicitacaoId, triagem)
    return request
  }


  async confirmarDataAgendamento(params: any) {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.putNovaDataSolicitacao(params.solicitacaoId, params)
    return response
  }

  async enviarNotificacaoWhatsapp(medicoSolicitanteId: string, params: any) {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.enviarNotificacaoWhatsapp(medicoSolicitanteId, params)
    return response
  }
}

interface ITriagem extends ICoreBase {
  confirmarTriagem(triagem: AgendamentoTriagemConfirmar): Promise<ResponseApi>
  confirmarDataAgendamento(params: any): Promise<ResponseApi>
  backofficeAgendamentoRealizaTriagem(solicitacaoId: string, params: any): Promise<ResponseApi>
  backofficeAgendamentoRealizaTriagemParticular(solicitacaoId: string, params: any): Promise<ResponseApi>
  enviarNotificacaoWhatsapp(medicoSolicitanteId: string, params: any): Promise<ResponseApi>
}

export {
  Triagem,
  ITriagem,
}
